import script from "./appLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./appLayout.vue?vue&type=script&setup=true&lang=js"

import "./appLayout.vue?vue&type=style&index=0&id=5cf6254a&lang=scss"

const __exports__ = script;

export default __exports__